import { PageHeader } from "@/components/app/kit";
import { AuditTable } from "@/components/app/AuditTable";

export default function TenantAudit() {
  return (
    <div>
      <PageHeader eyebrow="Traçabilité" title="Journal d'audit du cabinet" subtitle="Actions réalisées par les utilisateurs de votre cabinet." />
      <AuditTable path="/t/audit" />
    </div>
  );
}
